import React from 'react';
import {usePaymentContext} from '../../contexts/PaymentContext';
import styles from './PaymentLink.module.scss';

const iframeID = 'payment-link';

const PaymentLink = () => {
  const {link} = usePaymentContext();

  return Boolean(link)
    ? (
      <div
        className={styles.paymentLinkContainer}
        data-testid={'payment-link'}
      >
        <iframe
          id={iframeID}
          src={link}
          className={styles.paymentLink}
        />
      </div>
    )
    : null;
};

export default PaymentLink;
